"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderBoxBase = void 0;

var _helpers = require("../../helpers");

var _primitives = require("../../platform/primitives");

var _Flex = require("../Flex");

var _styledSystem = require("styled-system");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 2px;\n  padding: ", "px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A `View` or `div` (depending on the platform) that has a common border
 * and padding set by default
 */
var BorderBoxBase = (0, _primitives.styledWrapper)(_Flex.Flex)(_templateObject(), (0, _helpers.color)("black10"), (0, _helpers.space)(2), _styledSystem.background, _styledSystem.height, _styledSystem.maxWidth, _styledSystem.space, _styledSystem.width);
exports.BorderBoxBase = BorderBoxBase;
//# sourceMappingURL=BorderBoxBase.js.map